<!-- eslint-disable max-len -->
<template>
  <div>
    <report-header
      :download="download"
      :report="report"
      :csv-data="csvData"
    />
    <div id="report">
      <report-result-query :query="query" />
      <v-card
        flat
        class="back"
        :loading="loading"
      >
        <div style="display: flex;align-items: center;justify-content: center;width: 60%;margin: 0 auto;text-align: center;flex-direction: row;">
          <report-result-box
            title="TOTAL DE TÍTULOS COM PALAVRA-CHAVE"
            :result="result.publicacoes ? result.publicacoes.length.toString() : '0'"
          />
          <report-result-box
            title="TOTAL DE PALAVRAS-CHAVE"
            :result="result.publicacoes && palavrasChaveQtd ? palavrasChaveQtd.toString() : '0'"
          />
        </div>
      </v-card>
      <div
        v-if="report === 'Palavras-chave - Relatório Descritivo'"
        style="display: flex;align-items: center;margin: 20px;"
      >
        <table class="tg">
          <tr>
            <th class="tg-0lax">REGISTRO</th>
            <th class="tg-0lax">TÍTULO</th>
            <th class="tg-0lax">LOCALIZAÇÃO</th>
            <th class="tg-0lax">PALAVRAS-CHAVE</th>
          </tr>
          <tr
            v-for="item in result.publicacoes"
            :key="item.id"
          >
            <td class="tg-0lax">{{item.registro}}</td>
            <td class="tg-0lax">{{item.titulo}}</td>
            <td class="tg-0lax">{{item.localizacao}}</td>
            <td class="tg-0lax">{{item.palavrasChave}}</td>
          </tr>
        </table>
      </div>
      <div
        v-if="report === 'Palavras-chave - Relatório Simples'"
        style="display: flex;align-items: center;margin: 20px;"
      >
        <table class="tg">
          <tr>
            <th class="tg-0lax">PALAVRA-CHAVE</th>
          </tr>
          <tr
            v-for="(item, key) in palavrasChaveFull"
            :key="key"
          >
            <td class="tg-0lax">{{key}} ({{item.length}} {{item.length > 1 ? 'títulos' : 'título'}})</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import reportHeader from '@/components/report-header.vue';
import reportResultBox from '@/components/report-result-box.vue';
import reportResultQuery from '@/components/report-result-query.vue';
import download from '@/mixins/download';

export default {
  components: {
    reportHeader,
    reportResultBox,
    reportResultQuery,
  },
  mixins: [download],
  data() {
    return {
      report: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate(to);
      if (to.query.type === 'simples') {
        vm.report = 'Palavras-chave - Relatório Simples';
      } else {
        vm.report = 'Palavras-chave - Relatório Descritivo';
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate(to);
    if (to.query.type === 'simples') {
      this.report = 'Palavras-chave - Relatório Simples';
    } else {
      this.report = 'Palavras-chave - Relatório Descritivo';
    }
    next();
  },
  computed: {
    ...mapGetters('views/reports/keyWords', [
      'result',
      'query',
      'csvData',
      'loading',
      'palavrasChaveFull',
      'palavrasChaveQtd',
    ]),
  },
  methods: {
    ...mapActions('views/reports/keyWords', ['afterRouteUpdate', 'download']),
  },
};
</script>
<style scoped>
.tg {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.tg td {
  font-size: 14px;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: #eceff0;
}
.tg th {
  font-size: 14px;
  font-weight: normal;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  color: #1e398d;
  border-color: #eceff0;
}
.tg .tg-0lax {
  text-align: left;
  vertical-align: top;
}
.back {
  background-color: #fafafa !important;
}
</style>
